import { useState } from "react"
import Input from "../../../../components/Input"
import { StepProps } from "../../../../components/Stepper"
import { BuyData } from "../../../../types/steps/buy"
import { useRequest } from "../../../../hooks/useRequest"
import { userStore } from "../../../../store/userStore"
import PaymentHoldBanner from "../../../../components/PaymentHoldBanner"
import { saveOrderPaymentMethod } from "../../../../lib/orderPaymentMethodStorage"

export default function Pushkin({ navigate, params }: StepProps<BuyData>) {
    const { payInfo, orderId, orderNumber, orderCreatedAt, orderExpiredAt } = params
    const { totalPrice } = payInfo
    const { user } = userStore()
    const [form, setForm] = useState({
        lastname: user?.last_name || "",
        firstname: user?.first_name || "",
        patronymic: user?.patronymic || ""
    })
    const [loading, setLoading] = useState(false)
    const { request } = useRequest()

    const pay = async () => {
        try {
            setLoading(true)
            const resPayment = await request("POST", `user/order/${orderId}/payment`, {
                method: "pushkin_card",
                fio: `${form.lastname} ${form.firstname} ${form.patronymic}`.trim()
            })
            saveOrderPaymentMethod(orderId, "pushkin_card")
            navigate(
                "payStatus",
                {
                    orderNumber: orderNumber,
                    orderId: orderId,
                    orderCreatedAt,
                    orderExpiredAt,
                    paymentRedirectUrl: resPayment.redirect_url,
                },
                "replace",
            )
        } finally {
            setLoading(false)
        }
    }
    return (
        <div className="flex min-h-0 w-full min-w-0 max-w-full flex-1 flex-col items-center gap-[29.5px] overflow-x-hidden overflow-y-auto overscroll-x-none px-5 pt-3.5 pb-[max(1.25rem,var(--safe-bottom))]">
            <PaymentHoldBanner createdAt={orderCreatedAt} expiredAt={orderExpiredAt} className="w-full" />
            <div className="flex w-full flex-col gap-2.5">
                <Input
                    value={form.lastname}
                    required
                    label="Фамилия"
                    placeholder="Введите фамилию"
                    onChange={value => setForm({ ...form, lastname: value })}
                />
                <Input
                    value={form.firstname}
                    required
                    label="Имя"
                    placeholder="Введите имя"
                    onChange={value => setForm({ ...form, firstname: value })}
                />
                <Input
                    value={form.patronymic}
                    label="Отчество"
                    placeholder="Введите отчество"
                    onChange={value => setForm({ ...form, patronymic: value })}
                />
            </div>
            <div className="flex w-full flex-col items-center gap-5 rounded-[7px] bg-[#3A4666] px-[15px] pt-2.5 pb-5">
                <div className="flex items-center gap-2.5">
                    <img src={require("../../../../assets/pushkin-2.png")} alt="" />
                    <div className="text-[17px]/[24px] font-semibold tracking-[-0.4px]">Правила покупки билетов</div>
                </div>
                <div className="flex flex-col gap-2.5">
                    <div className="text-text/60 text-[13px]/[16px]">
                        Один билет на один сеанс — это максимальное количество, которое можно приобрести по «Пушкинской карте»
                    </div>
                    <div className="text-text/60 text-[13px]/[16px]">
                        Убедитесь, что при покупке билета вы вводите свои реальные фамилию, имя и отчество, точно как указано в профиле
                        “Госуслуги Культура”
                    </div>
                    <div className="text-text/60 text-[13px]/[16px]">
                        При посещении мероприятия обязательно возьмите с собой паспорт или другой документ, подтверждающий личность
                    </div>
                    <div className="text-text/60 text-[13px]/[16px]">
                        Если вы попытаетесь купить несколько билетов на один сеанс по одной карте, это может привести к блокировке
                        «Пушкинской карты»
                    </div>
                </div>
                <div className="text-primary text-[15px]/[20px] tracking-[-0.24px] underline">Правила программы “Пушкинская карта”</div>
            </div>

            <button
                className={`bg-accent h-[50px] min-h-[50px] w-full shrink-0 cursor-pointer rounded-[9px] ${loading ? "opacity-50" : ""}`}
                onClick={pay}>
                Оплатить {totalPrice.toLocaleString("ru-RU", { currency: "RUB", style: "currency", maximumFractionDigits: 0 })}
            </button>
        </div>
    )
}
